export default __webpack_public_path__ + "static/media/Apple.39ee4244.svg";